<mat-expansion-panel [expanded]="false" class="files-card">
  <mat-expansion-panel-header collapsedHeight="100px" expandedHeight="100px">
    <mat-panel-title>
      <h2>{{ 'ppwrDocuments.title' | transloco }}</h2>
    </mat-panel-title>
  </mat-expansion-panel-header>

  <mat-card-content class="table-container-wide">
    <div *ngIf="documents && documents.length > 0">
      <div class="pdfs-container">
        <div *ngFor="let ppwrdoc of documents; let i = index" class="file-container">
          <mat-form-field #formFieldInput [ngStyle]="{ 'width.px': nameFieldWidth[i] }" appearance="outline" class="name-input-container">
            <input
              matInput
              class="name-input"
              [(ngModel)]="ppwrdoc.name"
              (paste)="resizeInput(i)"
              (cut)="resizeInput(i)"
              (input)="resizeInput(i)"
              (change)="onNameEditClicked(i)"
              (click)="setCurrentNameBeforeChange(documents, i)"
              [disabled]="!canEditForm" />
            <mat-icon matPrefix>edit</mat-icon>
            <mat-icon matSuffix *ngIf="ppwrdoc.name.length === 0" class="error-name-icon">error</mat-icon>
          </mat-form-field>

          <span class="spacer"></span>

          <div class="doc-type-badge" [class.doc]="ppwrdoc.documentType === PpwrDocumentType.DoC" [class.td]="ppwrdoc.documentType === PpwrDocumentType.TD">
            {{ ppwrdoc.documentType === PpwrDocumentType.DoC ? ('ppwrDocuments.typeDoc' | transloco) : ('ppwrDocuments.typeTd' | transloco) }}
          </div>

          <div class="doc-source-badge" [class.paco]="ppwrdoc.source === PpwrDocumentSource.PacoGenerated" [class.user]="ppwrdoc.source === PpwrDocumentSource.UserUploaded">
            {{ ppwrdoc.source === PpwrDocumentSource.PacoGenerated ? ('ppwrDocuments.sourcePaco' | transloco) : ('ppwrDocuments.sourceUser' | transloco) }}
          </div>

          <button mat-icon-button color="primary" type="button" (click)="onViewDocumentClick(ppwrdoc)" matTooltip="{{ 'pdf.tooltips.viewPdf' | transloco }}">
            <mat-icon>preview</mat-icon>
          </button>

          <button
            [class.hidden]="ppwrdoc.source === PpwrDocumentSource.PacoGenerated"
            mat-icon-button
            color="primary"
            type="button"
            [disabled]="!canEditForm"
            (click)="onDeleteClick(ppwrdoc)"
            matTooltip="{{ 'pdf.tooltips.deletePdf' | transloco }}">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </div>
    </div>

    <div *ngIf="canEditForm">
      <input type="file" accept=".pdf" #docInput onclick="value=null" style="display: none" (change)="onFileSelected($event, PpwrDocumentType.DoC)" />
      <input type="file" accept=".pdf" #tdInput onclick="value=null" style="display: none" (change)="onFileSelected($event, PpwrDocumentType.TD)" />

      <button mat-raised-button color="primary" class="custom-button-top" type="button" (click)="docInput.click()">
        <mat-icon class="material-icons left">add</mat-icon>
        {{ 'ppwrDocuments.uploadDoc' | transloco }}
      </button>

      <button mat-raised-button color="primary" class="custom-button-top" type="button" (click)="tdInput.click()">
        <mat-icon class="material-icons left">add</mat-icon>
        {{ 'ppwrDocuments.uploadTd' | transloco }}
      </button>
    </div>
  </mat-card-content>
</mat-expansion-panel>
